import { Skeleton } from "antd"
import { memo } from "react"

interface VirtualTableStaticSkeletonProps {
  rowHeight?: number
}

function VirtualTableStaticSkeleton(props: VirtualTableStaticSkeletonProps) {
  return (
    <div className="rounded-xl bg-base-100 border border-solid border-separator-active">
      {Array.from({ length: 10 }).map((_, index) => (
        <div
          key={index}
          className="h-14 flex justify-center flex-col gap-3 px-4"
          style={{ height: props.rowHeight, borderBottom: "1px solid var(--separator-active)" }}
        >
          <Skeleton.Input
            active
            style={{
              width: Math.random() * 300 + 40,
              height: 10,
              minWidth: 50,
            }}
            className="rounded-lg flex items-center"
          />
          <Skeleton.Input
            active
            style={{
              width: Math.random() * 300 + 40,
              height: 10,
              minWidth: 50,
            }}
            className="rounded-lg flex items-center"
          />
        </div>
      ))}
    </div>
  )
}

export default memo(VirtualTableStaticSkeleton)
